<div class="pix-key-select-dialog">

    <div mat-dialog-title class="dialog-header" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
            <div class="header-icon-wrapper" [class.select-mode]="isSelectMode">
                <mat-icon>{{ isSelectMode ? 'tune' : 'pix' }}</mat-icon>
            </div>
            <div fxLayout="column">
                <h2 class="dialog-title">
                    {{ isSelectMode ? 'Definir Chave Padrão' : 'Chaves PIX' }}
                </h2>
                <span class="dialog-subtitle">
                    {{ isSelectMode ? 'Selecione a chave que deseja definir como padrão' : (data.merchant.merchantName || data.merchant.socialName) }}
                </span>
            </div>
        </div>
        <button mat-icon-button class="close-btn" (click)="onClose()" matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="dialog-content">

        <div class="merchant-banner" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <mat-icon class="banner-icon">store</mat-icon>
                <span class="banner-name">{{ data.merchant.merchantName || data.merchant.socialName }}</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px">
                <mat-icon class="banner-doc-icon">badge</mat-icon>
                <span class="banner-value">{{ data.merchant.documentNumber }}</span>
            </div>
        </div>

        <p class="section-hint" *ngIf="isSelectMode">
            <mat-icon>info_outline</mat-icon>
            Clique em uma chave para defini-la como padrão
        </p>

        <div class="keys-list" *ngIf="data.merchant.pixKeys?.length; else emptyState">
            <div class="key-card"
                *ngFor="let key of data.merchant.pixKeys"
                [class.is-default]="key.isDefault"
                [class.is-selectable]="isSelectMode && !key.isDefault && !loadingKeyId"
                [class.is-loading]="loadingKeyId === key.id"
                (click)="isSelectMode && !key.isDefault && !loadingKeyId && onSetDefault(key)">

                <div class="key-card-inner" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="14px">

                    <div class="type-icon-box" [class]="'type-' + (key.keyType?.toLowerCase() || 'unknown')">
                        <mat-icon>{{ getTypeIcon(key.keyType) }}</mat-icon>
                    </div>

                    <div class="key-info" fxLayout="column" fxLayoutGap="2px" fxFlex>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <span class="key-description">{{ key.description || key.pixKey }}</span>
                            <span class="type-badge" [class]="'badge-' + (key.keyType?.toLowerCase() || 'unknown')">
                                {{ getTypeLabel(key.keyType) }}
                            </span>
                            <span class="default-badge" *ngIf="key.isDefault">
                                <mat-icon>star</mat-icon>Padrão
                            </span>
                        </div>
                        <span class="key-value">{{ key.pixKey }}</span>
                    </div>

                    <!-- Select mode: indicator por estado -->
                    <ng-container *ngIf="isSelectMode">
                        <mat-spinner *ngIf="loadingKeyId === key.id" diameter="20" class="key-spinner"></mat-spinner>
                        <mat-icon *ngIf="key.isDefault && loadingKeyId !== key.id" class="current-default-icon">check_circle</mat-icon>
                        <mat-icon *ngIf="!key.isDefault && loadingKeyId !== key.id" class="select-arrow-icon">chevron_right</mat-icon>
                    </ng-container>

                </div>
            </div>
        </div>

        <ng-template #emptyState>
            <div class="empty-state" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
                <mat-icon>key_off</mat-icon>
                <span>Nenhuma chave PIX cadastrada para este comerciante</span>
            </div>
        </ng-template>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions" fxLayout="row" fxLayoutAlign="end center">
        <button mat-stroked-button color="primary" (click)="onClose()" [disabled]="!!loadingKeyId">Fechar</button>
    </mat-dialog-actions>

</div>
